module.exports = __webpack_public_path__ + "static/media/fasad.05f5c9a8.jpeg";